export const state = {
  data: [],
  status: ''
}

export const mutations = {
  SET_STATUS (state, payload) {
    state.status = payload
  },
  SET_DATA (state, payload) {
    state.data = payload
  }
}
